var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"size":"lg","id":_vm.id,"hide-footer":"","hide-header":""}},[_c('h1',{staticClass:"text-center text-primary"},[_vm._v("Terms of Use")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.tos)}})])}
var staticRenderFns = []

export { render, staticRenderFns }